import { render, staticRenderFns } from "./AlbumDetail.vue?vue&type=template&id=6b2b9464&scoped=true&"
import script from "./AlbumDetail.vue?vue&type=script&lang=ts&"
export * from "./AlbumDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumDetail.vue?vue&type=style&index=0&id=6b2b9464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b9464",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VRow,VToolbar})
